<template>
    <b-container>
        <router-link
            v-if="editMode"
            :to="{ name: 'student_settings', params: { id } }"
        >&larr; Back to Student Settings</router-link>
        <router-link
            v-else
            :to="{ name: 'my_students' }"
        >&larr; Back to My Students</router-link>

        <b-alert
            class="mt-4"
            variant="secondary"
            :show="true"
        >
            <h2>{{ title }}</h2>
            <p class="text-danger">
                <font-awesome-icon icon="exclamation-circle" class="mr-2" />
                Indicates required fields
            </p>
        </b-alert>
        <StudentFormFields
            :student="students.find((student) => student.id == id)"
            :disabled="working"
        >
            <template #submitBtn="{ student, btnDisabled }">
                <div class="mt-2 text-center">
                    <button
                        class="sc-btn pill"
                        @click="save(student)"
                        :disabled="btnDisabled"
                    >
                        <font-awesome-icon :icon="buttonIcon" class="mr-2" />
                        {{ buttonText }}
                    </button>
                </div>
            </template>
        </StudentFormFields>
    </b-container>
</template>
<script>
import StudentFormFields from "./StudentFormFields.vue";
import { mapState } from 'vuex';

export default {
    name: "addit-student",
    props: [ "id" ],
    data () {
        return {
            working: false
        };
    },
    computed: {
        editMode() {
            return !!this.id;
        },
        title() {
            return (this.editMode) ? "Edit Student" : "Add Student";
        },
        buttonText() {
            return (this.editMode) ? "Save Student" : "Add Student";
        },
        buttonIcon() {
            return (this.editMode) ? "save" : "plus-circle";
        },
        alertTitle() {
            return (this.editMode) ? "Student saved successfully." : "New student added successfully.";
        },
        ...mapState(["students"])
    },
    methods: {
        save(student) {
            this.$emit("disabled", true);
            this.working = true;

            this.$api.post(
                "/api/student/save",
                { student }
            ).then(({ data: { success, error, model }}) => {
                if (success) {
                    this.$store.commit("updateStudent", model);
                    this.$bvToast.toast(success.message || this.alertTitle, {
                        title: success.title || this.alertTitle,
                        autoHideDelay: 5000,
                        appendToast: true
                    });

                    this.$router.push({ name: 'student_settings', params: { id: model.id } });
                    this.$emit('close');
                } else {
                    this.$bvToast.toast(error, {
                        title           :   `Error saving student!`,
                        autoHideDelay   :   5000,
                        appendToast     :   true
                    });
                }
                this.working = false;
            });
        }
    },
    components: { StudentFormFields }
}
</script>